<template>
  <main
    class="text-center text-white flex justify-center items-center relative pt-16 sm:pt-8"
    id="contact"
  >
    <Teleport to="body">
      <NoticeView v-if="open" @close="open = false" />
    </Teleport>

    <div
      class="relative z-40 bg-[#EF2305] max-w-2xl w-full py-6 rounded-3xl m-auto px-6 mx-4"
    >
      <h1 class="text-white text-2xl adlam mb-6 pt-4">
        <img src="@/assets/images/letter.png" class="mx-auto" />
        <p>CONTACT</p>
      </h1>
      <form class="relative z-50">
        <div class="form-item">
          <label>Votre nom*</label>
          <input
            @input="error.lastname = ''"
            :disabled="loadingState"
            required
            v-model="form.lastname"
            id="lastname"
            type="text"
          />
          <span v-if="error.lastname" class="error">*{{ error.lastname }}</span>
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Votre prénom*</label>
          <input
            @input="error.firstname = ''"
            :disabled="loadingState"
            required
            v-model="form.firstname"
            id="firstname"
            type="text"
          />
          <span v-if="error.firstname" class="error"
            >*{{ error.firstname }}</span
          >
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Votre adresse email*</label>
          <input
            @input="error.email = ''"
            :disabled="loadingState"
            required
            v-model="form.email"
            class="w-full"
            id="email"
            type="email"
          />
          <span v-if="error.email" class="error">*{{ error.email }}</span>
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Type de demande*</label>
          <select
            :disabled="loadingState"
            required
            id="status"
            name="contact[statut]"
            class="form-control form-control"
            v-model="form.objet"
          >
            <option value="" disabled selected>Choisissez une option</option>

            <option>Problème technique lors de ma participation</option>
            <option>Je n'arrive pas à télécharger mes preuves d'achat</option>
            <option>Le site de l'offre ne fonctionne pas</option>
            <option>Demande d'information sur l'offre</option>
            <option>
              Mon ou mes produit(s) est (sont)-il(s) éligible(s) à l'offre?
            </option>
            <option>
              Demande de suivi concernant l'expédition de ma dotation
            </option>
            <option>Autre</option>
          </select>
          <span v-if="error.objet" class="error">*{{ error.objet }}</span>
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Objet*</label>
          <input
            @input="error.object = ''"
            :disabled="loadingState"
            required
            v-model="form.object"
            id="object"
            type="text"
          />
          <span v-if="error.object" class="error">*{{ error.object }}</span>
        </div>
        <div class="form-item">
          <label>Message*</label>
          <textarea
            @input="error.message = ''"
            id="contact_message"
            name="message"
            required="required"
            class="form-control form-control h-36"
            v-model="form.message"
          ></textarea>
          <span v-if="error.message" class="error">*{{ error.message }}</span>
        </div>
        <div class="text-xs italic text-left md:-mt-4">
          *Champs obligatoires
        </div>
        <p class="text-xs mt-4 italic text-justify">
          Ferrero France commerciale traite les données recueillies sur la base
          de votre consentement pour gérer votre participation à ce jeu. Pour en
          savoir plus sur la gestion de vos données personnelles et pour exercer
          vos droits, reportez-vous à la
          <a class="underline cursor-pointer" @click="open = true"
            >notice ci-jointe</a
          >.
        </p>
      </form>
      <div class="w-full text-center mb-6">
        <p v-if="!loadingState">
          <a
            @click.prevent="getResult"
            class="button w-44 !bg-white mt-8 !text-red-600"
            >ENVOYER</a
          >
        </p>
        <p v-if="loadingState" class="btn block m-auto my-6 font-veneer !px-16">
          Chargement...
        </p>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import NoticeView from "@/components/NoticeView.vue";
import Teleport from "vue2-teleport";
export default {
  data: function () {
    return {
      error: {},
      open: false,
      loadingState: false,
      required_field: ["lastname", "firstname", "object", "email", "message"],
      operationId: "6798e1b0cf8bf754eed61ce3",
      idgame: "2025-Agence TMS-292",
      subid: "",
      uid: "",
      done: false,
      form: {
        object: "",
        operation: undefined,
        youare: "Particulier",
        civilite: "MR",
        addr: {},
      },
    };
  },
  components: {
    NoticeView,
    Teleport,
  },
  async mounted() {
    try {
      this.operationId = "6798e1b0cf8bf754eed61ce3";
      this.idgame = "2025-Agence TMS-292";
      this.subid = sessionStorage.getItem("subid") || null;
      this.uid = sessionStorage.getItem("subid") || null;

      this.scrollToTop();

      if (this.subid != null && this.uid != null) {
        let { data: submission } = await axios.get(
          `https://api-gabarit.promo.dev/api/v2/submissions/${this.subid}?uid=${this.uid}`
        );

        if (submission) {
          this.form = {
            society: "",
            subid: this.subid,
            operationId: this.operationId,
            lastname: submission.last_name,
            firstname: submission.first_name,
            email: submission.email,
            email_confirmation: submission.email,
          };
        }
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    isRequired(value) {
      return value ? true : "Ce champ est requis";
    },
    getResult() {
      try {
        this.loadingState = true;
        let error = 0;

        for (let key of this.required_field) {
          if (!this.form[key] || this.form[key] == "") {
            this.error[key] = "Ce champ est requis";
            error++;
          }
        }
        if (error > 0) {
          this.loadingState = false;
          return;
        }

        let id = sessionStorage.getItem("_id");

        if (id == null) id = "n/a";

        if (error === 0) {
          var formDatas = {
            civilite: "Mr",
            operationId: this.operationId,
            nom: this.form.lastname,
            prenom: this.form.firstname,
            email: this.form.email,
            subid: this.subid,
            society: this.form.society,
            demande: this.idgame,
            objet: this.form.objet,
            message: this.form.message,
            idgame: this.idgame,
            type: "plateforme",
          };
          axios
            .post(
              `https://api-gabarit.promo.dev/api/operations-custom/promodev-send-contact/sendmail`,
              formDatas
            )
            .then(() => {
              this.loadingState = false;
              this.dialogState = true;
              this.form = {};
              this.done = true;
            });
        } else {
          this.loadingState = false;
        }
      } catch (e) {
        console.log(e);
        this.loadingState = false;
      }
    },
  },
};
</script>
<style>
#contact .error {
  @apply text-red-700 text-left block w-full py-1;
  color: #fff;
}
</style>
